export class OperationsApi {

    #client;

    /**
     * @param {ServerData} client
     * */
    constructor(client) {
        this.#client = client;
    }

    /**
     * @param {string} buildingId
     * @param {string} apartmentNumber
     * @param {string} paymentLink
     * @param {string} fileType
     * @param {string} fileName
     * @param {string} fileBase64
     * @param {boolean} toOwner
     * @param {boolean} toRenter
     * @return {Promise<{ success: boolean, renter?: unknown, owner?: unknown }>}
     * */
    sendWarningLetter(buildingId, apartmentNumber, paymentLink, fileType, fileName, fileBase64, toOwner, toRenter) {
        const payload = { paymentLink, fileType, fileName, fileBase64, toOwner, toRenter };
        return this.#client.post(`/managers/operations/send_warning_letter/${buildingId}/${apartmentNumber}`, payload);
    }

    /**
     * @param {string} buildingId
     * @param {array} tenants
     * @param {{ byEmail: boolean, bySMS: boolean, byIVR: boolean }} methods
     * @return {Promise<unknown>}
     * */
    sendPaymentRequests(buildingId, tenants, methods) {
        const payload = {tenants: tenants, methods: methods};

        return this.#client.post(`/managers/operations/request_payment/${buildingId}`, payload);
    }

    /**
     * @param {string} buildingId
     * @param {number} paymentPlanId
     * @param {{
     *     startPaymentDetailsID?: number;
     *     allPending: boolean;
     *     stopFrom?: DateStruct;
     * }} options
     * */
    shortenPlan(buildingId, paymentPlanId, options) {
        const payload = {...options};
        return this.#client.post(`/managers/operations/shorten-plan/${buildingId}/${paymentPlanId}`, payload);
    }

    /**
     * @param {string} buildingId
     * @param {number} paymentID
     * @param {boolean} sendEmail
     * */
    refund(buildingId, paymentID, sendEmail) {
        return this.#client.post(`/managers/operations/refund/${buildingId}`, { paymentID, sendEmail });
    }

    /**
     * @param {string} buildingId
     * @param {string} apartmentNum
     * */
    inactivateApartment(buildingId, apartmentNum) {
        return this.#client.patch(`/managers/operations/inactivate/building/${buildingId}/apartment/${apartmentNum}`);
    }

    async getShortLink(link) {
        return await this.#client.post('/managers/operations/link/short', { link });
    }

    /**
     * @param {{ tenants: [{type: string, apartmentNumber: string, tenantID: number }],senderName: string, methods: { byEmail: boolean, bySMS: boolean}, personalizedMessage: string }} params
     * * */
    async sendMultiplePlatformMessages(buildingID, params){
        return await this.#client.post(`/managers/operations/messagePlatform/${buildingID}`, params);
    }
    /**
     * @param {string} buildingID
     * @return {Promise<{messageCount: {sms: number, email: number}>}
     * */
    async getMessagesCount(buildingID) {
        return await this.#client.get(`/managers/operations/messagePlatform/count/${buildingID}`);
    }
}
